<template>
  <div>
    <div>
      <contents-box>
        <div :class="$style.graph_title">継続</div>
        <div v-if="!flag.notFound">
          <div v-if="countAnalytics" :class="$style.row">
              <Line
                :chart-options="chartOptions"
                :chart-data="countAnalytics"
                chart-id="line-text-chart"
                css-classes="graphStyle"
                width="400"
                height="200"
                :class="$style['col-9']"
              />
            </div>
        </div>
        <spacer :y="2"/>
        <div :class="$style.graph_title">間隔</div>
        <div
          :class="[$style.row, $style.count_graph]" v-if="!flag.notFound">
          <div v-if="intervalAnalytics && intervalAnalytics.totalData">
            <max-bar-graph
              :datasets-data="intervalAnalytics"
              :labels-data="countAnalytics.labels"
              :class="$style['col-9']" />
          </div>
          <div>
            <spacer :y="4" />
            <div v-if="intervalAnalytics && intervalAnalytics.data"
              :class="$style.interval_table_outer">
              <table border="1" :class="$style.interval_table" v-if="intervalAnalytics.data">
                <tr v-for="week, j of intervalAnalytics.maxWeek + 1"
                :key="week">
                  <td
                    v-for="(countWeekData, i) of intervalAnalytics.data"
                    v-if="intervalAnalytics.maxWeek === j"
                    :key="countWeekData"
                    :class="Boolean(typeof countWeekData[week - 1] === 'string') && Boolean(countWeekData[week - 1].indexOf('w') >= 0) ? $style.interval_table_sticky : $style.interval_table_relative"
                    :style="(week !== intervalAnalytics.maxWeek + 1) && (i !== 0) && (countWeekData[week - 1] !== null) ? `background-color: ${getIntervalCellBgColor(countWeekData[week - 1])}` : ''">
                    <div v-if="(typeof countWeekData[week - 1]) === 'string'" :class="countWeekData[week - 1].indexOf('w') >= 0 ? $style.sticky_flame : ''">{{ countWeekData[week - 1] }}</div>
                    <div v-else
                      :class="$style.hide_column"
                      v-on:mouseover="toggleShow(j, i)"
                      v-on:mouseleave="toggleHide(j, i)">　
                      <div v-if="flag.showFlag
                        && flag.showFlag[j]
                        && flag.showFlag[j][i]
                        && countWeekData[week - 1] !== null"
                        :class="(intervalAnalytics.data.length - (i + 2) > 0) ? $style.balloon : $style.balloon_right_alg">
                        ココモニチェック(ave):{{ countWeekData[week - 1] }}
                      </div>
                    </div>
                    </td>
                </tr>
                <tr v-if="countData && countData.text">
                  <td :class="$style.interval_table_wide">相談件数</td>
                  <td
                    v-for="index of countData.text.length"
                    :key="index"
                    :class="$style.data_cel">
                    {{ countData.text[index - 1] + countData.online[index - 1] }}
                  </td>
                </tr>
                <tr v-if="targetRange === 'common'">
                  <td :class="$style.interval_table_wide">テキスト</td>
                  <td
                    v-for="index of countData.text.length"
                    :key="index">
                    {{ countData.text[index - 1] || 0 }}
                  </td>
                </tr>
                <tr v-if="targetRange === 'common'">
                  <td :class="$style.interval_table_wide">オンライン</td>
                  <td
                    v-for="index of countData.text.length"
                    :key="index">
                    {{ countData.online[index - 1] || 0 }}
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <spacer :y="2" />
          <div :class="$style['col-3']">
            <div>
              <p :class="$style.filter_title">グラフタイプ</p>
              <div :class="$style.filter_contents">
                <ul :class="$style.btns">
                  <li
                    v-for="row in targetTypes"
                    :key="row.name">
                    <input
                      type="radio"
                      name="graph-type"
                      :id="row.name"
                      :value="row.name"
                      v-model="targetType"
                      :checked="targetType === row.name"
                      @change="getAnalyticsCount">
                    <label
                      :for="row.name"
                      :class="$style.btn">{{ row.label }}</label>
                  </li>
                </ul>
              </div>
            </div>

            <div :class="$style.filter_flex">
              <div>
                <p :class="$style.filter_title">範囲</p>
                <div :class="$style.filter_contents">
                  <select
                    :class="$style.select_box"
                    name="targetRange"
                    id="targetRange"
                    v-model="targetRange"
                    @change="getAnalyticsCount">
                    <option
                      v-for="row in targetRanges"
                      :key="row.name"
                      :value="row.name"
                      :selected="targetRange === row.name">{{ row.label }}</option>
                  </select>
                </div>
              </div>

              <spacer :x="2" />
              <div>
                <p :class="$style.filter_title">学校・企業</p>
                <div :class="$style.filter_contents">
                  <select
                    :class="$style.select_box"
                    name="schoolFilter"
                    id="schoolFilter"
                    v-model="targetSchool"
                    @change="getAnalyticsCount">
                    <option
                      :value="0"
                      :selected="targetSchool === 0">すべて</option>
                    <option
                      v-for="school of filters.schools"
                      :key="school"
                      :selected="school.id === targetSchool">{{ school.name }}</option>
                  </select>
                </div>
              </div>

              <spacer v-if="targetType === 'customer' && (targetSchool && filters.users)" :x="2" />
              <div v-if="targetType === 'customer'
                && (targetSchool && filters.users)">
                <p :class="$style.filter_title">利用者</p>
                <div :class="$style.filter_contents">
                  <select
                    :class="$style.select_box"
                    name="userFilter"
                    id="userFilter"
                    v-model="targetUser"
                    @change="getAnalyticsCount">
                    <option
                      :value="0"
                      :selected="targetUser === 0">すべて</option>
                    <option
                      v-for="user of filters.users"
                      :key="user"
                      :selected="user === targetUser">{{ user }}</option>
                  </select>
                </div>
              </div>

              <spacer :x="2" />
              <div>
                <p :class="$style.filter_title">回数</p>
                <div :class="$style.filter_contents">
                  <select
                    :class="$style.select_box"
                    name="countFilter"
                    id="countFilter"
                    v-model="targetCount"
                    @change="getAnalyticsCount">
                    <option
                      :value="0"
                      :selected="targetCount === 0">すべて</option>
                    <option
                      v-show="count >= 2"
                      v-for="count of filters.counts"
                      :key="count"
                      :selected="count === targetCount">{{ count }}</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
        </div>
        <p v-else>表示できるデータが有りませんでした。</p>
      </contents-box>
      <!-- 5回までの相談変遷 -->
      <spacer :y="2" />
      <contents-box v-if="typeTransition" type="inner">
        <div :class="$style.graph_title">相談変遷（2022年6月1日〜現在）</div>
        <spacer :y="1" />
        <table
          border="1"
          :class="$style.history_changes_graph">
          <tbody>
            <tr :class="$style.history_changes_graph_center">
              <th colspan="2">初回</th>
              <th colspan="2">2回目</th>
              <th colspan="2">3回目</th>
              <th colspan="2">4回目</th>
              <th colspan="2">5回目</th>
            </tr>
            <tr>
              <th :class="$style.o" rowspan="16">online</th>
              <td rowspan="16">
                count: {{ typeTransition['o----'].count }}<br>
                score: {{ Math.floor((typeTransition['o----'].who5 / typeTransition['o----'].count) * 10) / 10 || 0 }}
              </td>
              <th :class="$style.o" rowspan="8">online</th>
              <td rowspan="8" :style="isHalf('oo---', 'o----') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oo---'].count }}<br>
                    score: {{ Math.floor((typeTransition['oo---'].who5 / typeTransition['oo---'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oo---'].count" :class="transitionArrow('oo---', 'o----')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="4">online</th>
              <td rowspan="4" :style="isHalf('ooo--', 'oo---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ooo--'].count }}<br>
                    score: {{ Math.floor((typeTransition['ooo--'].who5 / typeTransition['ooo--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ooo--'].count" :class="transitionArrow('ooo--', 'oo---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('oooo-', 'ooo--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oooo-'].count }}<br>
                    score: {{ Math.floor((typeTransition['oooo-'].who5 / typeTransition['oooo-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oooo-'].count"  :class="transitionArrow('oooo-', 'ooo--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ooooo', 'oooo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ooooo'].count }}<br>
                    score: {{ Math.floor((typeTransition['ooooo'].who5 / typeTransition['ooooo'].count) * 10) / 10 || 0 }}
                  </div>

                  <div v-if="typeTransition['ooooo'].count" :class="transitionArrow('ooooo', 'oooo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('oooot', 'oooo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oooot'].count }}<br>
                    score: {{ Math.floor((typeTransition['oooot'].who5 / typeTransition['oooot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oooot'].count" :class="transitionArrow('oooot', 'oooo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('ooot-', 'ooo--') ? 'border: red 2px solid;' : 'auto'" >
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ooot-'].count }}<br>
                    score: {{ Math.floor((typeTransition['ooot-'].who5 / typeTransition['ooot-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ooot-'].count"  :class="transitionArrow('ooot-', 'ooo--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('oooto', 'ooot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oooto'].count }}<br>
                    score: {{ Math.floor((typeTransition['oooto'].who5 / typeTransition['oooto'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oooto'].count" :class="transitionArrow('oooto', 'ooot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('ooott', 'ooot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ooott'].count }}<br>
                    score: {{ Math.floor((typeTransition['ooott'].who5 / typeTransition['ooott'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ooott'].count" :class="transitionArrow('ooott', 'ooot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="4">text</th>
              <td rowspan="4" :style="isHalf('oot--', 'oo---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oot--'].count }}<br>
                    score: {{ Math.floor((typeTransition['oot--'].who5 / typeTransition['oot--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oot--'].count" :class="transitionArrow('oot--', 'oo---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('ooto-', 'oot--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ooto-'].count }}<br>
                    score: {{ Math.floor((typeTransition['ooto-'].who5 / typeTransition['ooto-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ooto-'].count" :class="transitionArrow('ooto-', 'oot--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ootoo', 'ooto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ootoo'].count }}<br>
                    score: {{ Math.floor((typeTransition['ootoo'].who5 / typeTransition['ootoo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ootoo'].count"  :class="transitionArrow('ootoo', 'ooto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('ootot', 'ooto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ootot'].count }}<br>
                    score: {{ Math.floor((typeTransition['ootot'].who5 / typeTransition['ootot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ootot'].count" :class="transitionArrow('ootot', 'ooto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('oott-', 'oot--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oott-'].count }}<br>
                    score: {{ Math.floor((typeTransition['oott-'].who5 / typeTransition['oott-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oott-'].count"  :class="transitionArrow('oott-', 'oot--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ootto', 'oott-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ootto'].count }}<br>
                    score: {{ Math.floor((typeTransition['ootto'].who5 / typeTransition['ootto'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ootto'].count" :class="transitionArrow('ootto', 'oott-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('oottt', 'oott-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oottt'].count }}<br>
                    score: {{ Math.floor((typeTransition['oottt'].who5 / typeTransition['oottt'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oottt'].count" :class="transitionArrow('oottt', 'oott-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="8">text</th>
              <td rowspan="8" :style="isHalf('ot---', 'o----') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ot---'].count }}<br>
                    score: {{ Math.floor((typeTransition['ot---'].who5 / typeTransition['ot---'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ot---'].count" :class="transitionArrow('ot---', 'o----')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="4">online</th>
              <td rowspan="4" :style="isHalf('oto--', 'ot---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['oto--'].count }}<br>
                    score: {{ Math.floor((typeTransition['oto--'].who5 / typeTransition['oto--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['oto--'].count" :class="transitionArrow('oto--', 'ot---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('otoo-', 'oto--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['otoo-'].count }}<br>
                    score: {{ Math.floor((typeTransition['otoo-'].who5 / typeTransition['otoo-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['otoo-'].count"  :class="transitionArrow('otoo-', 'oto--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('otooo', 'otoo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['otooo'].count }}<br>
                    score: {{ Math.floor((typeTransition['otooo'].who5 / typeTransition['otooo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['otooo'].count" :class="transitionArrow('otooo', 'otoo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('otoot', 'otoo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['otoot'].count }}<br>
                    score: {{ Math.floor((typeTransition['otoot'].who5 / typeTransition['otoot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['otoot'].count" :class="transitionArrow('otoot', 'otoo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('otot-', 'oto--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['otot-'].count }}<br>
                    score: {{ Math.floor((typeTransition['otot-'].who5 / typeTransition['otot-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['otot-'].count" :class="transitionArrow('otot-', 'oto--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ototo', 'otot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ototo'].count }}<br>
                    score: {{ Math.floor((typeTransition['ototo'].who5 / typeTransition['ototo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ototo'].count" :class="transitionArrow('ototo', 'otot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('otott', 'otot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['otott'].count }}<br>
                    score: {{ Math.floor((typeTransition['otott'].who5 / typeTransition['otott'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['otott'].count" :class="transitionArrow('otott', 'otot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="4">text</th>
              <td rowspan="4" :style="isHalf('ott--', 'ot---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ott--'].count }}<br>
                    score: {{ Math.floor((typeTransition['ott--'].who5 / typeTransition['ott--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ott--'].count" :class="transitionArrow('ott--', 'ot---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('otto-', 'ott--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['otto-'].count }}<br>
                    score: {{ Math.floor((typeTransition['otto-'].who5 / typeTransition['otto-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['otto-'].count" :class="transitionArrow('otto-', 'ott--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ottoo', 'otto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ottoo'].count }}<br>
                    score: {{ Math.floor((typeTransition['ottoo'].who5 / typeTransition['ottoo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ottoo'].count" :class="transitionArrow('ottoo', 'otto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('ottot', 'otto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ottot'].count }}<br>
                    score: {{ Math.floor((typeTransition['ottot'].who5 / typeTransition['ottot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ottot'].count" :class="transitionArrow('ottot', 'otto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('ottt-', 'ott--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ottt-'].count }}<br>
                    score: {{ Math.floor((typeTransition['ottt-'].who5 / typeTransition['ottt-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ottt-'].count" :class="transitionArrow('ottt-', 'ott--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ottto', 'ottt-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ottto'].count }}<br>
                    score: {{ Math.floor((typeTransition['ottto'].who5 / typeTransition['ottto'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ottto'].count" :class="transitionArrow('ottto', 'ottt-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('otttt', 'ottt-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['otttt'].count }}<br>
                    score: {{ Math.floor((typeTransition['otttt'].who5 / typeTransition['otttt'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['otttt'].count" :class="transitionArrow('otttt', 'ottt-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="16">text</th>
              <td rowspan="16">
                count: {{ typeTransition['t----'].count }}<br>
                score: {{ Math.floor((typeTransition['t----'].who5 / typeTransition['t----'].count) * 10) / 10 || 0 }}
              </td>
              <th :class="$style.o" rowspan="8">online</th>
              <td rowspan="8" :style="isHalf('to---', 't----') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['to---'].count }}<br>
                    score: {{ Math.floor((typeTransition['to---'].who5 / typeTransition['to---'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['to---'].count" :class="transitionArrow('to---', 't----')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="4">online</th>
              <td rowspan="4" :style="isHalf('too--', 'to---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['too--'].count }}<br>
                    score: {{ Math.floor((typeTransition['too--'].who5 / typeTransition['too--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['too--'].count" :class="transitionArrow('too--', 'to---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('tooo-', 'too--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tooo-'].count }}<br>
                    score: {{ Math.floor((typeTransition['tooo-'].who5 / typeTransition['tooo-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tooo-'].count" :class="transitionArrow('tooo-', 'too--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td  :style="isHalf('toooo', 'tooo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['toooo'].count }}<br>
                    score: {{ Math.floor((typeTransition['toooo'].who5 / typeTransition['toooo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['toooo'].count" :class="transitionArrow('toooo', 'tooo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('tooot', 'tooo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tooot'].count }}<br>
                    score: {{ Math.floor((typeTransition['tooot'].who5 / typeTransition['tooot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tooot'].count" :class="transitionArrow('tooot', 'tooo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('toot-', 'too--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['toot-'].count }}<br>
                    score: {{ Math.floor((typeTransition['toot-'].who5 / typeTransition['toot-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['toot-'].count" :class="transitionArrow('toot-', 'too--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('tooto', 'toot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tooto'].count }}<br>
                    score: {{ Math.floor((typeTransition['tooto'].who5 / typeTransition['tooto'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tooto'].count" :class="transitionArrow('tooto', 'toot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('toott', 'toot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['toott'].count }}<br>
                    score: {{ Math.floor((typeTransition['toott'].who5 / typeTransition['toott'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['toott'].count" :class="transitionArrow('toott', 'toot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="4">text</th>
              <td rowspan="4" :style="isHalf('tot--', 'to---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tot--'].count }}<br>
                    score: {{ Math.floor((typeTransition['tot--'].who5 / typeTransition['tot--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tot--'].count" :class="transitionArrow('tot--', 'to---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('toto-', 'tot--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['toto-'].count }}<br>
                    score: {{ Math.floor((typeTransition['toto-'].who5 / typeTransition['toto-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['toto-'].count" :class="transitionArrow('toto-', 'tot--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('totoo', 'toto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['totoo'].count }}<br>
                    score: {{ Math.floor((typeTransition['totoo'].who5 / typeTransition['totoo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['totoo'].count" :class="transitionArrow('totoo', 'toto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('totot', 'toto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['totot'].count }}<br>
                    score: {{ Math.floor((typeTransition['totot'].who5 / typeTransition['totot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['totot'].count" :class="transitionArrow('totot', 'toto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('tott-', 'tot--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tott-'].count }}<br>
                    score: {{ Math.floor((typeTransition['tott-'].who5 / typeTransition['tott-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tott-'].count" :class="transitionArrow('tott-', 'tot--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('totto', 'tott-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['totto'].count }}<br>
                    score: {{ Math.floor((typeTransition['totto'].who5 / typeTransition['totto'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['totto'].count" :class="transitionArrow('totto', 'tott-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('tottt', 'tott-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tottt'].count }}<br>
                    score: {{Math.floor((typeTransition['tottt'].who5 / typeTransition['tottt'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tottt'].count" :class="transitionArrow('tottt', 'tott-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="8">text</th>
              <td rowspan="8" :style="isHalf('tt---', 't----') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tt---'].count }}<br>
                    score: {{ Math.floor((typeTransition['tt---'].who5 / typeTransition['tt---'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tt---'].count" :class="transitionArrow('tt---', 't----')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="4">online</th>
              <td rowspan="4" :style="isHalf('tto--', 'tt---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tto--'].count }}<br>
                    score: {{ Math.floor((typeTransition['tto--'].who5 / typeTransition['tto--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tto--'].count" :class="transitionArrow('tto--', 'tt---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('ttoo-', 'tto--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttoo-'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttoo-'].who5 / typeTransition['ttoo-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttoo-'].count" :class="transitionArrow('ttoo-', 'tto--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ttooo', 'ttoo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttooo'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttooo'].who5 / typeTransition['ttooo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttooo'].count" :class="transitionArrow('ttooo', 'ttoo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('ttoot', 'ttoo-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttoot'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttoot'].who5 / typeTransition['ttoot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttoot'].count" :class="transitionArrow('ttoot', 'ttoo-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('ttot-', 'tto--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttot-'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttot-'].who5 / typeTransition['ttot-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttot-'].count" :class="transitionArrow('ttot-', 'tto--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('ttoto', 'ttot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttoto'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttoto'].who5 / typeTransition['ttoto'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttoto'].count" :class="transitionArrow('ttoto', 'ttot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('ttott', 'ttot-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttott'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttott'].who5 / typeTransition['ttott'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttott'].count" :class="transitionArrow('ttott', 'ttot-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="4">text</th>
              <td rowspan="4" :style="isHalf('ttt--', 'tt---') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttt--'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttt--'].who5 / typeTransition['ttt--'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttt--'].count" :class="transitionArrow('ttt--', 'tt---')" />
                </div>
              </td>
              <th :class="$style.o" rowspan="2">online</th>
              <td rowspan="2" :style="isHalf('ttto-', 'ttt--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttto-'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttto-'].who5 / typeTransition['ttto-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttto-'].count" :class="transitionArrow('ttto-', 'ttt--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('tttoo', 'ttto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tttoo'].count }}<br>
                    score: {{ Math.floor((typeTransition['tttoo'].who5 / typeTransition['tttoo'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tttoo'].count" :class="transitionArrow('tttoo', 'ttto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('tttot', 'ttto-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tttot'].count }}<br>
                    score: {{ Math.floor((typeTransition['tttot'].who5 / typeTransition['tttot'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tttot'].count" :class="transitionArrow('tttot', 'ttto-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t" rowspan="2">text</th>
              <td rowspan="2" :style="isHalf('tttt-', 'ttt--') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tttt-'].count }}<br>
                    score: {{ Math.floor((typeTransition['tttt-'].who5 / typeTransition['tttt-'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tttt-'].count" :class="transitionArrow('tttt-', 'ttt--')" />
                </div>
              </td>
              <th :class="$style.o">online</th>
              <td :style="isHalf('tttto', 'tttt-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['tttto'].count }}<br>
                    score: {{ Math.floor((typeTransition['tttto'].who5 / typeTransition['tttto'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['tttto'].count" :class="transitionArrow('tttto', 'tttt-')" />
                </div>
              </td>
            </tr>
            <tr>
              <th :class="$style.t">text</th>
              <td :style="isHalf('ttttt', 'tttt-') ? 'border: red 2px solid;' : 'auto'">
                <div :class="$style.history_changes_graph_datas">
                  <div>
                    count: {{ typeTransition['ttttt'].count }}<br>
                    score: {{ Math.floor((typeTransition['ttttt'].who5 / typeTransition['ttttt'].count) * 10) / 10 || 0 }}
                  </div>
                  <div v-if="typeTransition['ttttt'].count" :class="transitionArrow('ttttt', 'tttt-')" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </contents-box>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';
import ContentsBox from '@/views/components/ContentsBox.vue';
import MaxBarGraph from '@/views/components/MaxBarGraph.vue';
import { Line } from 'vue-chartjs';
import annotationPlugin from 'chartjs-plugin-annotation';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
} from 'chart.js';
import { cloneDeep } from 'lodash';
import Spacer from '@/views/components/Spacer.vue';
import { CHART_BASE_COLORS, CHART_COLORS, rgbaString } from '@/constants/color';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, annotationPlugin);

export default {
  name: 'OperatorAnalyticsGraph',
  components: {
    Line,
    ContentsBox,
    MaxBarGraph,
    Spacer,
  },
  props: {
    backendData: {
      type: Object,
    },
    allFilter: {
      type: Object,
    },
    schools: {
      type: Object,
    },
    analyticsApiPrefix: {
      type: String,
      default: '/v1/analytics',
    },
    authHeaders: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      transitionOnlineBg: CHART_COLORS.transition.online,
      transitionTextBg: CHART_COLORS.transition.text,
      countAnalytics: null,
      intervalAnalytics: null,
      countData: null,
      targetCommonData: null,
      allTarget: null,
      typeTransition: null,
      flag: {
        loader: false,
        notFound: false,
        initial: true,
        showFlag: [],
      },
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        scales: {
          x: {
            scaleLabel: {
              display: true,
              labelString: '回数',
            },
            ticks: {
              stepSize: 1,
            },
          },
          y: {
            max: 25, // who-5の最大値（満点25点）
            min: 0,
            scaleLabel: {
              display: true,
              labelString: 'WHO5スコア',
              fontColor: 'gray',
              fontSize: 16,
            },
            grid: {
              drawBorder: false,
              display: true,
              tickColor: 'rgba(255, 255, 255, 0)',
            },
          },
        },
        plugins: {
          tooltip: {
            callbacks: {
              title: () => null,
              label: (item) => {
                let string = '';
                if (this.targetType === 'average') {
                  // 平均値
                  string = [
                    ` ${item.raw.meta.type}`,
                    `平均スコア: ${item.raw.meta.score}`,
                    `相談件数: ${item.raw.meta.total}`,
                  ];
                } else if (this.targetType === 'customer') {
                  // 利用者別
                  string = [
                    ` ユーザID: ${item.raw.meta.user_id}`,
                    `スコア: ${item.raw.meta.score}`,
                    `相談日: ${item.raw.meta.created_at}`,
                  ];
                }
                return string;
              },
            },
          },
          legend: {
            display: false,
          },
        },
      },
      ctx: null,
      annotationHover: false,
      userIds: [],
      targetUser: 0,
      targetSchool: 0,
      targetCount: 0,
      targetType: 'average',
      targetTypes: [
        { name: 'average', label: '平均値' },
        { name: 'customer', label: '利用者別' },
      ],
      targetRange: 'common',
      targetRanges: [
        { name: 'common', label: 'オンライン＋テキスト' },
        { name: 'text', label: 'テキスト' },
        { name: 'reserve', label: 'オンライン' },
      ],
      filters: {
        schools: [],
        users: [],
        counts: 0,
      },
      graphSettings: {
        baseColor: CHART_BASE_COLORS.GENERAL_BLUE,
        types: {
          common: {
            label: 'オンライン＋テキスト',
            averageColorAlpha: 1,
          },
          reserve: {
            label: 'オンライン',
            averageColorAlpha: 0.65,
          },
          text: {
            label: 'テキスト',
            averageColorAlpha: 0.3,
          },
        },
      },
    };
  },
  async created() {
    this.readParameter();
    this.getAnalyticsCount();
    this.gethistoryChanges();
  },
  watch: {
    backendData: {
      handler() {
        this.getAnalyticsCount();
      },
      deep: true,
    },
    // グラフタイプ変更時のリセット
    targetType: {
      handler(after, before) {
        if (after !== before) {
          if (!this.flag.initial) {
            this.targetSchool = 0;
            this.targetUser = 0;
            this.targetCount = 0;
            this.targetRange = 'common';
          }
          const query = { ...this.$route.query };
          query.targetRange = this.targetRange;
          query.targetType = after;
          this.$router.push({ query });
          this.readParameter();
          if (this.flag.initial) {
            this.flag.initial = false;
          }
        }
      },
      deep: true,
    },
    schools: {
      handler() {
        this.readParameter();
        this.filters.schools = this.schools;
      },
      deep: true,
    },
    // 利用者別「範囲」変更時のリセット
    targetRange: {
      handler(after, before) {
        if (after !== before) {
          this.targetSchool = 0;
          this.targetUser = 0;
          this.targetCount = 0;
          const targetRange = this.targetRange;
          const query = { ...this.$route.query };
          query.targetRange = targetRange;
          this.$router.push({ query });
          this.readParameter();
        }
      },
      deep: true,
    },
    targetSchool: {
      handler(newVal) {
        if (newVal !== 0) {
          const query = { ...this.$route.query };
          this.schools.forEach((row) => {
            if (row.name === this.targetSchool) {
              query.targetSchool = row.id;
              this.$router.push({ query });
            }
          });
        } else if (newVal === 0) {
          const query = { ...this.$route.query };
          if (query.targetSchool) {
            delete query.targetSchool;
            this.$router.push({ query });
          }
        }
      },
      deep: true,
    },
    targetCount: {
      handler(newVal) {
        if (newVal !== 0) {
          const targetCount = newVal;
          const query = { ...this.$route.query };
          if (query.targetCount !== targetCount) {
            query.targetCount = targetCount;
            this.$router.push({ query });
          }
        } else {
          const query = { ...this.$route.query };
          if (query.targetCount) {
            delete query.targetCount;
            this.$router.push({ query });
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(['helper']),
  },
  methods: {
    // 回数別アナリティクスデータの取得
    getAnalyticsCount() {
      this.flag.initial = false;
      this.readParameter();
      // 特定の利用者で絞り込んだ時にIDを取得
      let targetUser;
      let targetSchool;
      let targetSchoolID;
      let targetRange;
      if (this.targetUser) targetUser = this.targetUser.substring(7);
      if (this.targetSchool) {
        targetSchool = this.schools.find((data) => data.name === this.targetSchool);
        targetSchoolID = targetSchool.id;
      }
      if (this.targetRange === 'reserve') { //　表記をbackendではonlineで統一
        targetRange = 'online';
      } else {
        targetRange = this.targetRange;
      }

      const params = {
        start: this.allFilter.start,
        end: this.allFilter.end,
        account_types: this.allFilter.account_types,
        school_types: this.allFilter.school_types,
        targetSchool: this.allFilter.targetSchool,
        targetArea: this.allFilter.targetArea,
        targetOrganizationType: this.allFilter.targetOrganizationType,
        graphType: this.targetType,
        graphRange: targetRange,
        graphCount: this.targetCount,
        countTargetSchool: targetSchoolID,
        targetUser,
      };

      this.axios({
        method: 'GET',
        url: `${this.analyticsApiPrefix}/get/countData`,
        params,
        headers: this.authHeaders,
      })
        .then((response) => {
          this.countAnalytics = response.data.data;
          this.intervalAnalytics = response.data.intervalData;
          this.countData = response.data.countData;
          this.filters.counts = response.data.data.labels.length;
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },

    // 利用者の相談タイプの変遷
    gethistoryChanges() {
      this.readParameter();
      // 特定の利用者で絞り込んだ時にIDを取得
      let targetUser;
      let targetSchool;
      let targetSchoolID;
      let targetRange;
      if (this.targetUser) targetUser = this.targetUser.substring(7);
      if (this.targetSchool) {
        targetSchool = this.schools.find((data) => data.name === this.targetSchool);
        targetSchoolID = targetSchool.id;
      }
      if (this.targetRange === 'reserve') { //　表記をbackendではonlineで統一
        targetRange = 'online';
      } else {
        targetRange = this.targetRange;
      }

      const params = {
        start: this.allFilter.start,
        end: this.allFilter.end,
        account_types: this.allFilter.account_types,
        school_types: this.allFilter.school_types,
        targetSchool: this.allFilter.targetSchool,
        targetArea: this.allFilter.targetArea,
        targetOrganizationType: this.allFilter.targetOrganizationType,
        graphType: this.targetType,
        graphRange: targetRange,
        graphCount: this.targetCount,
        countTargetSchool: targetSchoolID,
        targetUser,
      };

      this.axios({
        method: 'GET',
        url: `${this.analyticsApiPrefix}/get/historyChanges`,
        params,
        headers: this.authHeaders,
      })
        .then((response) => {
          this.typeTransition = response.data;
        })
        .catch((error) => {
          if (error.message) {
            console.log(error.message);
          } else {
            console.log(error);
          }
        });
    },

    // 半数以上あるかを判定
    isHalf(current, above) {
      let result = false;

      if ((this.typeTransition[current].count / this.typeTransition[above].count) >= 0.5) {
        result = true;
      }

      return result;
    },

    // 遷移グラフで1つ上のデータよりココモニが上がったか下がったのか、同じかを判定
    transitionArrow(current, above) {
      let result;
      const currentScore = Math.floor((this.typeTransition[current].who5 / this.typeTransition[current].count) * 10) / 10 || 0;
      const aboveScore = Math.floor((this.typeTransition[above].who5 / this.typeTransition[above].count) * 10) / 10 || 0;

      if (currentScore > aboveScore) {
        result = this.$style.transition_up;
      }
      if (currentScore < aboveScore) {
        result = this.$style.transition_down;
      }
      if (currentScore === aboveScore) {
        result = this.$style.transition_same;
      }

      return result;
    },

    /**
     * 平均値
     *   学校
     *   回数
     *
     * 利用者別
     *   範囲（すべて・オンライン・テキスト）
     *   学校
     *     利用者
     *   回数
     */
    readParameter() {
      // 現在のクエリを取得する
      const query = this.$route.query;
      if (query.tab === 'analyticsselect') {
        if (query.targetType && this.flag.initial) {
          this.targetType = query.targetType;
        }
        if (query.targetRange && this.flag.initial) {
          this.targetRange = query.targetRange;
        }
        if (query.targetSchool) {
          const schoolQuery = Number(query.targetSchool);
          if (schoolQuery && this.schools) {
            this.schools.forEach((row) => {
              if (row.id === schoolQuery) {
                this.targetSchool = row.name;
              }
            });
          }
        }
        if (query.targetCount && this.flag.initial) {
          const countQuery = Number(query.targetCount);
          this.targetCount = countQuery;
        }
      }
    },
    initialize() {
      this.getAnalyticsCount();
      this.flag.loader = true;
      this.chartData = { labels: [], datasets: [] };

      let max = 1;
      if (this.targetType === 'average') {
        // 平均値の計算
        const averageValues = this.getAverageValues();
        // 取得した平均値からグラフを描画
        const types = Object.keys(averageValues);

        types.forEach((type) => {
          const data = [];
          const values = averageValues[type];
          const counts = Object.keys(values);
          if (counts.length > max) max = counts.length;
          counts.forEach((count) => {
            const average = values[count].average;
            data.push({
              x: Number(count),
              y: average,
              meta: {
                type: this.graphSettings.types[type].label,
                score: average,
                total: values[count].total,
              },
            });
          });
          const baseColor = this.graphSettings.baseColor;
          const color = `${baseColor.r}, ${baseColor.g}, ${baseColor.b}`;
          this.chartData.datasets.push({
            borderColor: `rgba(${color}, ${this.graphSettings.types[type].averageColorAlpha})`,
            borderWidth: 3,
            radius: 2,
            data,
          });
        });
      } else if (this.targetType === 'customer') {
        const customerValues = this.getCustomerValues();

        const keys = Object.keys(customerValues);
        const length = keys.length;
        keys.forEach((id, i) => {
          if (customerValues[id].length > max) max = customerValues[id].length;
          const data = customerValues[id];
          const rgb = this.generateRGB(length, i);
          this.chartData.datasets.push({
            borderColor: rgb,
            borderWidth: 3,
            radius: 2,
            data,
          });
          // 凡例用にIDとカラーを保存
          this.userIds.push({
            id: customerValues[id][0].meta.user_name,
            color: rgb,
          });
        });
      }

      this.chartData.labels = [...Array(max)].map((_, i) => i + 1);
      this.flag.loader = false;
    },

    /**
     * 各タイプの平均値取得
     */
    getAverageValues() {
      const ls = cf.getLocalStorage('wtt');
      const original = cloneDeep(ls.analytics);

      // 選択可能な学校の洗い出し
      this.setFilterdSchools(original.common);

      const types = Object.keys(original);
      // 回数毎のデータに形成しなおす
      const countValues = {};
      types.forEach((type) => {
        countValues[type] = {};
        const data = original[type];
        const ids = Object.keys(data);
        ids.forEach((id) => {
          const values = data[id];
          values.forEach((value) => {
            if (!countValues[type][value.x]) countValues[type][value.x] = [];
            // 学校で絞り込み（対象の学校でなければ除外）
            if (this.targetSchool && value.meta.school !== this.targetSchool) return false;
            // 回数で絞り込み（除外処理）
            if (Number(this.targetCount) && value.x > this.targetCount) return false;
            countValues[type][value.x].push(value.y);
          });
        });
      });

      // 回数毎の平均値を計算して返却
      const result = {};
      types.forEach((type) => {
        result[type] = {};
        const data = countValues[type];
        const counts = Object.keys(data);
        counts.forEach((count) => {
          const values = data[count];
          if (values.length) {
            const average = values.reduce((a, b) => a + b) / values.length;
            // 平均値は小数点第三位を四捨五入して返却
            result[type][count] = {
              total: values.length,
              average: cf.methods.roundN(average, 2),
            };
          }
        });
      });

      return result;
    },

    /**
     * 利用者別のスコア形成
     */
    getCustomerValues() {
      const ls = cf.getLocalStorage('wtt');
      const original = cloneDeep(ls.analytics);
      const datas = original[this.targetRange];

      // 選択可能な学校の洗い出し
      this.setFilterdSchools(datas);
      // 選択可能な（学校に紐づく）利用者
      if (this.targetSchool) this.setFilteredUsers(datas);

      const result = {};
      const ids = Object.keys(datas);
      ids.forEach((id) => {
        result[id] = [];
        const values = datas[id];
        values.forEach((value) => {
          // 学校で絞り込み（対象の学校でなければ除外）
          if (this.targetSchool && value.meta.school !== this.targetSchool) return false;
          // ユーザーで絞り込み（除外処理）
          if (this.targetUser && value.meta.user_id !== this.targetUser) return false;
          // 回数で絞り込み（除外処理）
          if (Number(this.targetCount) && value.x > this.targetCount) return false;

          result[id].push(value);
        });
      });

      // ソート後に空配列のidは削除
      ids.forEach((id) => {
        const values = result[id];
        if (!values.length) delete result[id];
      });

      return result;
    },


    // 選択項目の学校
    setFilterdSchools(datas) {
      const schools = [];
      const ids = Object.keys(datas);
      ids.forEach((id) => {
        const values = datas[id];
        values.forEach((value) => {
          if (!schools.includes(value.meta.school)) {
            schools.push(value.meta.school);
          }
        });
      });
      this.filters.schools = schools;
    },

    // 選択した学校に紐づくユーザ配列
    setFilteredUsers(datas) {
      const users = [];
      const ids = Object.keys(datas);
      ids.forEach((id) => {
        const values = datas[id];
        values.forEach((value) => {
          if ((value.meta.school === this.targetSchool)
            && !users.includes(value.meta.user_id)) {
            users.push(value.meta.user_id);
          }
        });
      });
      this.filters.users = users;
    },


    /**
     * 利用者別の折れ線色生成
     */
    generateRGB(length, index) {
      // const r = Math.floor(Math.random() * 256);
      // const g = Math.floor(Math.random() * 256);
      // const b = Math.floor(Math.random() * 256);
      // return `rgb(${r}, ${g}, ${b})`;
      const baseColor = this.graphSettings.baseColor;
      const min = 3;
      const max = 10;
      const diff = max - min;
      const unit = diff / length;
      const value = (unit * (index + 1) + min);
      const alpha = value / 10;
      return `rgba(${baseColor.r}, ${baseColor.g}, ${baseColor.b}, ${alpha})`;
    },

    toggleShow(j, i) {
      this.flag.showFlag.length = j;
      this.flag.showFlag[j] = [];
      this.flag.showFlag[j].length = i;
      this.flag.showFlag[j][i] = true;
    },
    toggleHide(j, i) {
      this.flag.showFlag[j][i] = false;
    },
    // 間隔テーブルのセル背景色を計算
    getIntervalCellBgColor(value) {
      return rgbaString(CHART_BASE_COLORS.GENERAL_BLUE, (value / 25) + 0.08);
    },
  },
};
</script>

<style lang="scss" module>
.graph_title {
  padding: 3px;
  font-size: 1.1em;
  font-weight: 500;
}
.guide {
  display: block;
  // text-align: right;
  float: right;
  >div {
    display: flex;
  }
  &_who5 {
    display: inline;
  }
  &_who5:before {
    font-size: 1em;
    content: '●';
    position: relative;
    left: -5px;
  }
}
.filter {
  &_container {
    // display: flex;
    // @include md-view {
    //   display: block;
    // }
  }
  &_title {
    padding-top: 8px;
  }
}
.select {
  margin-left: -10px;
  display: flex;
  flex-wrap: wrap;
  &_elem {
    margin-left: 10px;
  }
  &_box {
    max-width: 220px;
    padding: 13px;
    background-color: var(--gray-sub);
    border: none;
    outline: none;
    border-radius: 8px;
    appearance: none;

    &_wrap {
      display: flex;

      li {
        &:not(:last-child) {
          margin-right: 10px;
        }
      }
    }
  }
}
.btns {
  display: flex;
  // width: 102%;
  width: 100%;
  li {
    margin-right: 1em;
  }
  input[type=radio] {
    display: none;
    &:checked {
      + label {
        background-color: var(--orange-main);
      }
    }
  }
}

.polygonal {
  width: 85%;
  @media screen and (max-width: 1420px) {
    max-width: 470px;
  }
  @media screen and (max-width: 1200px) {
    max-width: 100%;
  }
}

.btn {
  padding: 6px 20px;
  font-size: 14px;
  text-align: center;
  border: none;
  background-color: #ababab;
  font-weight: bold;
  color: #fff;
  transition: 0.4s all;
  display: inline-block;
  border-radius: 20px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  cursor: pointer;
  &:not(:disabled) {
    &:hover {
      background-color: var(--orange-main);
    }
  }
  &:disabled {
    opacity: .5;
    cursor: default;
  }
}

.row {
  // display: flex;
  margin-left:  - 1em;
  width: 100%;
    .col {
      flex: 1;
      @for $num from 1 through 12 {
        &-#{$num} {
          flex: $num;
          padding: 0 1em;
        }
      }
    }
  @media screen and (max-width: 1200px) {
    flex-direction: column;
    width: 100%;
    .col {
      max-width: 100%;
      @for $num from 1 through 12 {
        &-#{$num} {
          flex: 1;
          padding: 1em 0;
        }
      }
    }
  }
}
.count_graph {
  padding-left: .5em;
}

.filter_flex {
  display: flex;
}

.interval_table {
  // table-layout: fixed;
  // width: 100%;
  white-space: pre;
  border: 1px solid var(--gray);
  border-collapse: collapse;
  text-align: center;
  &_outer {
    overflow: scroll;
  }
  &_wide {
    width: 100px;
  }
  &_sticky {
    position: sticky;
    background-color: white;
    left: 0;
  }
  &_relative {
    width: 50px;
  }
}
.data_cel {
  width: 60px;
}

.sticky_flame{
  margin: -1px;
  border:  1px solid silver;
}

.hide_column {
  position: relative;
  width: 50px;
}

.balloon {
  position: absolute;
  border-radius: 5px;
  text-align: left;
  width: 150px;
  padding: 5px;
  background-color: #DDDDDD;
  &_right_alg {
    position: absolute;
    left: -100px;
    border-radius: 5px;
    text-align: left;
    width: 150px;
    padding: 5px;
    background-color: #DDDDDD;
  }
}

.balloon:before {
  content: "";
  position: absolute;
  top: -20px;
  left: 10%;
  margin-left: -15px;
  border: 15px solid transparent;
  border-bottom: 15px solid #DDDDDD;
}

.balloon_right_alg::before{
  content: "";
  position: absolute;
  top: -20px;
  left: 90%;
  margin-left: -15px;
  border: 15px solid transparent;
  border-bottom: 15px solid #DDDDDD;
}
.history_changes_graph {
  width: 100%;
  border-collapse: collapse;
  &_center {
    text-align: center;
  }
  td {
    padding: 0 .8em;
    text-align: center;

    .history_changes_graph_datas {
      display: flex;
      justify-content: left;
      align-items: center;
    }
    .transition_up {
      $size: 20px;
      background-image: url('/img/default/wtt_transition_up.png');
      background-repeat: no-repeat;
      background-size: contain;
      width: $size;
      height: $size;
      margin-left: .6em;
    }
    .transition_down {
      $size: 20px;
      background-image: url('/img/default/wtt_transition_down.png');
      background-repeat: no-repeat;
      background-size: contain;
      width: $size;
      height: $size;
      margin-left: .6em;
    }
    .transition_same {
      $size: 25px;
      background-image: url('/img/default/wtt_transition_same.png');
      background-repeat: no-repeat;
      background-size: contain;
      width: $size;
      height: $size;
      margin-left: .6em;
    }
  }
  th {
    &.o {
      background: v-bind(transitionOnlineBg);
    }
    &.t {
      background: v-bind(transitionTextBg);
    }
  }
}
</style>
